import * as React from "react";

import {
  Link,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
} from "@material-ui/core";

import { LoginForm } from "client/domain";
import { useBranding } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";
import { logAmplitudeEvent } from "client/lib/amplitude";

import { ValueProps } from "../RedesignSignUp";

import { BaseLoginLayout } from "./BaseLoginLayout";

const useStyles = makeStyles((theme: Theme) => {
  const { gray20 } = useNormalizedBrandPaletteValues(theme);

  return {
    heading: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: `${20 / 16}rem`,
    },
    helperText: {
      fontSize: `${14 / 16}rem`,
    },
    link: {
      color: gray20,
      textDecoration: "underline",
      cursor: "pointer",
    },
  };
});

const apUrl = "https://portal.afterpay.com/us/login-email";
const clearpayUrl = "https://portal.clearpay.co.uk/uk/login-email";
const emailHeader =
  "Enter your email address below to get started, or to resume your application.";

export const LoginFormVariant: React.FC<{ leftAlign: boolean }> = ({
  leftAlign,
}) => {
  const classes = useStyles();
  const { brandTitle } = useBranding();
  const url = brandTitle === "Afterpay" ? apUrl : clearpayUrl;

  const openLink = () => {
    window.open(url, "_blank");
    logAmplitudeEvent("REDESIGN_SIGN_UP", "click_customer_login_link");
  };

  const heading = (
    <Typography className={classes.heading}>
      <strong>Get {brandTitle} for your business.</strong>
    </Typography>
  );

  const helperText = (
    <Typography className={classes.helperText}>
      Not a business?{" "}
      <Link className={classes.link} onClick={openLink}>
        Go to our customer login page.
      </Link>
    </Typography>
  );
  return (
    <LoginForm
      leftAlign={leftAlign}
      heading={heading}
      emailHeader={emailHeader}
      emailHelperText={helperText}
    />
  );
};

export const ValuePropsVariant: React.FC = () => {
  const isMobileView = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  return (
    <BaseLoginLayout
      leftColumn={<ValueProps variant={"login"} isMobileView={isMobileView} />}
      rightColumn={<LoginFormVariant leftAlign={!isMobileView} />}
    />
  );
};
